import {
    escapePrintViewText,
    replaceMediaLikeTagsWithIds,
} from '@/common/questionPrintView/shared'

const hotSpotClueText = (clue) => {
    if (!clue) {
        return ''
    }

    if (clue.type === 'image' && clue.related_media_id) {
        return `image media id: ${escapePrintViewText(clue.related_media_id)}`
    }

    if (clue.text) {
        return escapePrintViewText(clue.text)
    }

    return ''
}

const buildHotSpotQuestionPrintView = (content) => {
    const questionHtml = replaceMediaLikeTagsWithIds(content.question || '')
    const backgroundImageMediaId = escapePrintViewText(
        content.image && content.image.related_media_id ? content.image.related_media_id : ''
    )
    const backgroundImageHtml = backgroundImageMediaId
        ? `<p>background image media id: ${backgroundImageMediaId}</p>`
        : ''
    const questionSectionHtml = questionHtml ? `<p>Question:</p>${questionHtml}` : ''
    const correctCluesHtml = (content.clues || [])
        .filter((clue) => clue.is_correct)
        .map((clue) => hotSpotClueText(clue))
        .filter(Boolean)
        .map((clueText) => `<p>${clueText}</p>`)
        .join('')
    const incorrectCluesHtml = (content.clues || [])
        .filter((clue) => !clue.is_correct)
        .map((clue) => hotSpotClueText(clue))
        .filter(Boolean)
        .map((clueText) => `<p>${clueText}</p>`)
        .join('')
    const correctCluesSectionHtml = correctCluesHtml
        ? `<p>&nbsp;</p><p>Correct Clues:</p>${correctCluesHtml}`
        : ''
    const incorrectCluesSectionHtml = incorrectCluesHtml
        ? `<p>&nbsp;</p><p>Incorrect Clues:</p>${incorrectCluesHtml}`
        : ''

    return `${questionSectionHtml}${backgroundImageHtml}${correctCluesSectionHtml}${incorrectCluesSectionHtml}`
}

export {buildHotSpotQuestionPrintView}
